import { createActions } from "@thewebops/admin-panel";

const actions = {
  downloadImportTemplate: createActions(`category_group/downloadImportTemplate`),
};

export default actions;
